export default __webpack_public_path__ + "static/media/promociones.b4e7fcc8.svg";